import { render, staticRenderFns } from "./XferToBinLocation.vue?vue&type=template&id=660c9a40&"
import script from "./XferToBinLocation.vue?vue&type=script&lang=js&"
export * from "./XferToBinLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports